<template>
  <v-app>
    <div>
      <mcity-toolbar
        :fullname="fullname"
        :username="username"
        :presentation-text="presentationText"
        :is-user-admin="isUserAdmin"
        :title="title"
      >
        <template slot="buttons">
          <v-btn
            flat
            to="/search"
            data-cy="new-reservation-btn"
          >
            New Reservation
          </v-btn>
          <v-btn
            flat
            v-if="isUserAdmin"
            to="/admin"
            data-cy="admin-panel-btn"
          >
            Admin
          </v-btn>
          <v-btn
            flat
            v-if="isUserAdmin"
            to="/usage"
            data-cy="usage-panel-btn"
          >
            Usage
          </v-btn>
        </template>
      </mcity-toolbar>
    </div>

    <v-content>
      <v-container fluid>
        <v-progress-circular
          v-show="isUserLoading"
          indeterminate
          class="mb-2"
        />
        <v-alert
          type="error"
          v-model="showRequestFailed"
          dismissible
        >
          Request Failed -
          If problem persists, please email mcity-engineering@umich.edu
        </v-alert>
        <v-alert
          color="success"
          v-model="showRequestSuccess"
          dismissible
        >
          Request Successful -
          Please check your inbox for reservation updates from mcity-services@umich.edu
        </v-alert>
        <router-view />
        <router-view name="auth" />
        <auth-refresh
          v-if="getShowIframe"
        />
      </v-container>
    </v-content>

    <v-footer
      dark
      color="primary"
      fixed
      app
      style="padding: 0rem 1rem"
    >
      <span>&copy; 2024-2028 The Regents of the University of Michigan</span>
      <v-spacer />
      <span>Contact Mcity at <a
        href="tel:7345489293"
        class="white-link"
      >(734) 548-9293</a> or <a
        href="mailto:mcity@umich.edu"
        class="white-link"
      >mcity@umich.edu</a> with booking questions.</span>
      <v-spacer />
      <span class="mr-1">{{ username }} : {{ today }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import authRefresh from '@mcity/mcity-vue-auth/src/components/RefreshAuthiFrame.vue'
import McityToolbar from '@mcity/mcity-vue-shared/components/McityToolbarVuetify1.5.vue'
import { dom } from '@fortawesome/fontawesome-svg-core'

export default {
  name: 'App',
  components: {
    authRefresh,
    McityToolbar
  },
  methods: {
    ...mapMutations([
      'logError'
    ])
  },
  watch: {
    errors (val) {
      this.showRequestFailed = true
      this.errorText = val[val.length - 1]
    }
  },
  computed: {
    ...mapState({
      getPresentMode: state => state.presentMode,
      isUserAdmin: state => state.isUserAdmin,
      isUserLoading: state => state.isUserLoading,
      errors: state => state.errors,
      user: state => state.session.user,
      getShowIframe: state => state.session.showIframe
    }),
    presentationText () {
      return this.getPresentMode ? 'Private' : 'Presentation'
    },
    today () {
      const date = new Date()
      return date.toISOString().slice(0, 10)
    },
    username () {
      return this.user && this.user.username ? this.user.username : 'placeholder@email.com'
    },
    fullname () {
      const user = this.user
      return user && user.first_name && user.last_name
        ? `${user.first_name} ${user.last_name}` : 'Firstname Lastname'
    }
  },
  data () {
    return {
      avatarMenu: false,
      clipped: false,
      showRequestFailed: false,
      showRequestSuccess: false,
      errorText: null,
      iframeURL: '/refresh.html',
      title: 'Scheduling'
    }
  },
  mounted () {
    // Required for FontAwesome SVG icons
    dom.watch()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f2f2f2;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.whiteM {
  fill:#fff;
  stroke: #fff;
}
.maizeM {
  fill:#f5c400;
}
.logo {
  display: block;
  width: 160px;
}
.small, small {
  font-size: 80%;
  font-weight: 400;
}
.presentation {
  font-size: 120% !important;
}
.date {
  position: absolute;
  bottom: 6px;
  right: 16px;
}
.link {
  display: block;
}
.white-link {
  color: #fff
}
</style>
